// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__Vj9mi","wrapper":"styles_wrapper__ZcsNd","btn":"styles_btn__DWKKP","content":"styles_content__xYW2j"};